import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDollarSign,
  faPercent,
  faUsers,
  faShoppingCart,
} from '@fortawesome/free-solid-svg-icons';
import { StatsGrid, StatCard, StatLabel, StatValue, StatHelp } from './Styles';
import { STAT_LABELS } from './constants';
import type { SummaryStatsProps } from './types';

const SummaryStats: React.FC<SummaryStatsProps> = ({
  stats,
  formatCurrency,
  formatPercentage,
}) => {
  const feePct =
    stats.totalRevenue > 0
      ? (stats.totalFees / stats.totalRevenue) * 100
      : 0;

  return (
    <StatsGrid>
      <StatCard>
        <StatLabel>{STAT_LABELS.TOTAL_REVENUE}</StatLabel>
        <StatValue>{formatCurrency(stats.totalRevenue)}</StatValue>
        <StatHelp>
          <FontAwesomeIcon icon={faDollarSign} /> {STAT_LABELS.ACROSS_MERCHANTS(stats.merchantCount)}
        </StatHelp>
      </StatCard>
      <StatCard>
        <StatLabel>{STAT_LABELS.TOTAL_FEES}</StatLabel>
        <StatValue>{formatCurrency(stats.totalFees)}</StatValue>
        <StatHelp>
          <FontAwesomeIcon icon={faPercent} /> {formatPercentage(feePct)} {STAT_LABELS.OF_REVENUE}
        </StatHelp>
      </StatCard>
      <StatCard>
        <StatLabel>{STAT_LABELS.NET_PAYOUTS_DUE}</StatLabel>
        <StatValue>{formatCurrency(stats.totalNetEarnings)}</StatValue>
        <StatHelp>
          <FontAwesomeIcon icon={faUsers} /> {STAT_LABELS.AMOUNT_TO_PAY}
        </StatHelp>
      </StatCard>
      <StatCard>
        <StatLabel>{STAT_LABELS.TOTAL_ORDERS}</StatLabel>
        <StatValue>{(stats.totalOrders ?? 0).toLocaleString()}</StatValue>
        <StatHelp>
          <FontAwesomeIcon icon={faShoppingCart} /> {STAT_LABELS.AVG(formatCurrency(stats.averageOrderValue))}
        </StatHelp>
      </StatCard>
    </StatsGrid>
  );
};

export default React.memo(SummaryStats);
